(() => {
  const normalizedText = (value = '') => String(value).replace(/\s+/g, ' ').trim().toLowerCase();

  const ensureMaterialsAddon = (section) => {
    const step = section.querySelector('[data-bcu-step="step-3"]');
    const sourceOption = step?.querySelector('[data-bcu-proxy="true"]');
    if (!step || !sourceOption) return;

    const cards = Array.from(sourceOption.querySelectorAll('.mw-option__value'));
    const paidCard = cards.find((card) => {
      const label = normalizedText(card.querySelector('.bcu-option-label__text')?.textContent || card.textContent);
      return label.includes('mitbringen') && !label.includes('nicht mitbringen');
    });
    const freeCard = cards.find((card) => (
      normalizedText(card.querySelector('.bcu-option-label__text')?.textContent || card.textContent)
        .includes('nicht mitbringen')
    ));
    const paidRadio = paidCard?.querySelector('input[type="radio"]');
    const freeRadio = freeCard?.querySelector('input[type="radio"]');
    if (!paidCard || !freeCard || !paidRadio || !freeRadio) return;

    sourceOption.classList.add('bcu-home-materials-source');
    if (sourceOption.getAttribute('aria-hidden') !== 'true') sourceOption.setAttribute('aria-hidden', 'true');

    const help = step.querySelector('.bcu-service-step__heading small');
    if (help && help.textContent !== 'Bitte wählen Sie eine der beiden Optionen aus.') {
      help.textContent = 'Bitte wählen Sie eine der beiden Optionen aus.';
    }

    if (section.dataset.bcuHomeMaterialsInitialised !== 'true') {
      section.dataset.bcuHomeMaterialsInitialised = 'true';
      section.dataset.bcuHomeMaterialsSelection = '';
    }

    const clearSourceSelection = () => {
      const currentProxy = step.querySelector('[data-bcu-proxy="true"]');
      const currentProxyRadios = Array.from(currentProxy?.querySelectorAll('input[type="radio"]') || []);
      const currentSourceName = currentProxyRadios[0]?.dataset.bcuSourceName || '';
      const currentSourceRadios = Array.from(section.querySelectorAll('form input[type="radio"]'))
        .filter((radio) => !radio.closest('[data-bcu-proxy="true"]') && radio.name === currentSourceName);
      [...currentProxyRadios, ...currentSourceRadios].forEach((radio) => {
        radio.checked = false;
        radio.removeAttribute('checked');
        radio.closest('.mw-option__value')?.classList.remove('mw-option__value--selected');
      });
      return currentProxyRadios[0] || null;
    };

    let ui = step.querySelector('[data-bcu-home-materials-options]');
    if (!ui) {
      step.querySelector('[data-bcu-home-materials-addon]')?.remove();
      ui = document.createElement('div');
      ui.className = 'bcu-home-materials-options';
      ui.dataset.bcuHomeMaterialsOptions = '';

      [
        { key: 'paid', card: paidCard, number: 1 },
        { key: 'free', card: freeCard, number: 2 },
      ].forEach(({ key, card, number }) => {
        const option = document.createElement('label');
        option.className = 'bcu-home-materials-option';
        option.dataset.bcuHomeMaterialsOption = key;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.dataset.bcuHomeMaterialsToggle = key;
        checkbox.setAttribute('aria-label', `Option ${number} auswählen`);
        checkbox.setAttribute('aria-required', 'true');

        const icon = card.querySelector('.bcu-option-icon')?.cloneNode(true);
        const copy = card.querySelector('.bcu-option-copy')?.cloneNode(true);
        const title = copy?.querySelector('.bcu-option-label__text');
        if (title) title.textContent = `Option ${number} – ${title.textContent.trim()}`;

        option.append(checkbox);
        if (icon) option.append(icon);
        if (copy) option.append(copy);
        ui.append(option);

        checkbox.addEventListener('change', () => {
          section.dataset.bcuHomeMaterialsSelection = checkbox.checked ? key : '';
          const currentOption = step.querySelector('[data-bcu-proxy="true"]');
          const currentCards = Array.from(currentOption?.querySelectorAll('.mw-option__value') || []);
          const desiredCard = currentCards.find((candidate) => {
            const label = normalizedText(candidate.querySelector('.bcu-option-label__text')?.textContent || candidate.textContent);
            return key === 'paid'
              ? label.includes('mitbringen') && !label.includes('nicht mitbringen')
              : label.includes('nicht mitbringen');
          });
          const desiredRadio = desiredCard?.querySelector('input[type="radio"]');
          if (checkbox.checked && desiredRadio && !desiredRadio.checked) desiredRadio.click();
          if (!checkbox.checked) {
            const clearedProxyRadio = clearSourceSelection();
            clearedProxyRadio?.dispatchEvent(new Event('change', { bubbles: true }));
          }
          window.setTimeout(() => ensureMaterialsAddon(section), 100);
        });
      });
      sourceOption.after(ui);
    }

    const selected = section.dataset.bcuHomeMaterialsSelection || '';
    const checkboxes = Array.from(ui.querySelectorAll('[data-bcu-home-materials-toggle]'));
    checkboxes.forEach((checkbox) => {
      const active = checkbox.dataset.bcuHomeMaterialsToggle === selected;
      checkbox.checked = active;
      checkbox.closest('[data-bcu-home-materials-option]')?.classList.toggle('is-selected', active);
    });
    if (checkboxes[0]) {
      checkboxes[0].setCustomValidity(selected ? '' : 'Bitte wählen Sie eine der beiden Optionen aus.');
    }

    const summary = section.querySelector('[data-bcu-summary="step-3"]');
    const expectedSummary = selected === 'paid'
      ? 'Reinigungsprodukte und Utensilien mitbringen'
      : selected === 'free'
        ? 'Reinigungsprodukte und Utensilien nicht mitbringen'
        : 'Keine ausgewählt';
    if (summary && summary.textContent.trim() !== expectedSummary) summary.textContent = expectedSummary;

    if (!selected) {
      clearSourceSelection();
      return;
    }

    const desiredRadio = selected === 'paid' ? paidRadio : freeRadio;
    if (!desiredRadio.checked) desiredRadio.click();
  };

  const installMaterialsAddon = (section) => {
    if (section.dataset.bcuHomeMaterialsObserver === 'true') {
      ensureMaterialsAddon(section);
      return;
    }
    section.dataset.bcuHomeMaterialsObserver = 'true';
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        ensureMaterialsAddon(section);
      });
    };
    new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
    schedule();
    [100, 350, 800, 1500, 3000, 6000].forEach((delay) => window.setTimeout(schedule, delay));
  };

  const enhance = (root = document) => {
    root.querySelectorAll?.('.bcu-service-page--generic[data-service-key="home-maintenance"]')
      .forEach((section) => {
        installMaterialsAddon(section);
        const step = section.querySelector('[data-bcu-step="step-2"]');
        const variants = step?.querySelector('.bcu-native-variant-options');
        if (!step || !variants || step.querySelector('[data-bcu-home-hours]')) return;

        variants.classList.add('bcu-home-hours-source');
        variants.setAttribute('aria-hidden', 'true');

        const stepper = document.createElement('div');
        stepper.className = 'bcu-home-hours';
        stepper.dataset.bcuHomeHours = '';
        stepper.innerHTML = `
          <button type="button" data-bcu-home-hours-change="-1" aria-label="Eine Reinigungsstunde weniger">−</button>
          <span class="bcu-home-hours__value" role="status" aria-live="polite">
            <strong data-bcu-home-hours-value></strong>
            <small>1 bis 10 Stunden frei wählbar</small>
          </span>
          <button type="button" data-bcu-home-hours-change="1" aria-label="Eine Reinigungsstunde mehr">+</button>
        `;
        variants.before(stepper);

        const radios = () => Array.from(variants.querySelectorAll('input[name="bcu-variant"]:not(:disabled)'));
        const render = () => {
          const available = radios();
          const selected = available.find((radio) => radio.checked) || available[0];
          const index = Math.max(0, available.indexOf(selected));
          const title = selected?.closest('.bcu-size-option')?.querySelector('strong')?.textContent?.trim() || '–';
          const hours = Number(title.match(/(\d+)/)?.[1] || 0);
          const output = stepper.querySelector('[data-bcu-home-hours-value]');
          const decrement = stepper.querySelector('[data-bcu-home-hours-change="-1"]');
          const increment = stepper.querySelector('[data-bcu-home-hours-change="1"]');
          if (output) output.textContent = title;
          if (decrement) decrement.disabled = !available.length || index <= 0;
          if (increment) increment.disabled = !available.length || index >= available.length - 1;

          if (hours > 0) {
            const summaryRow = section.querySelector('[data-bcu-duration-summary-row]');
            const summaryOutput = section.querySelector('[data-bcu-duration-summary]');
            const form = section.querySelector('form');
            let durationProperty = section.querySelector('[data-bcu-home-duration-property]');
            if (!durationProperty && form) {
              durationProperty = document.createElement('input');
              durationProperty.type = 'hidden';
              durationProperty.name = `properties[${section.dataset.bcuDurationSummaryLabel || 'Voraussichtliche Arbeitszeit'}]`;
              durationProperty.dataset.bcuHomeDurationProperty = '';
              form.appendChild(durationProperty);
            }
            if (summaryRow) summaryRow.hidden = false;
            if (summaryOutput) summaryOutput.textContent = `${hours} Std.`;
            if (durationProperty) durationProperty.value = `${hours} Std.`;
          }
        };

        stepper.querySelectorAll('[data-bcu-home-hours-change]').forEach((button) => {
          button.addEventListener('click', () => {
            const available = radios();
            const selectedIndex = Math.max(0, available.findIndex((radio) => radio.checked));
            const direction = Number(button.dataset.bcuHomeHoursChange || 0);
            const target = available[Math.min(available.length - 1, Math.max(0, selectedIndex + direction))];
            if (target && !target.checked) target.click();
            window.setTimeout(render, 0);
          });
        });

        section.addEventListener('change', () => window.setTimeout(render, 0));
        render();

        const durationSummary = section.querySelector('[data-bcu-duration-summary]');
        if (durationSummary && !durationSummary.dataset.bcuHomeDurationObserver) {
          durationSummary.dataset.bcuHomeDurationObserver = 'true';
          new MutationObserver(() => {
            const selected = radios().find((radio) => radio.checked) || radios()[0];
            const title = selected?.closest('.bcu-size-option')?.querySelector('strong')?.textContent?.trim() || '';
            const hours = Number(title.match(/(\d+)/)?.[1] || 0);
            if (!hours) return;
            const expected = `${hours} Std.`;
            const summaryRow = section.querySelector('[data-bcu-duration-summary-row]');
            const durationProperty = section.querySelector('[data-bcu-home-duration-property]');
            if (durationSummary.textContent !== expected) durationSummary.textContent = expected;
            if (summaryRow?.hidden) summaryRow.hidden = false;
            if (durationProperty && durationProperty.value !== expected) durationProperty.value = expected;
          }).observe(durationSummary, { childList: true, characterData: true, subtree: true });
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance());
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
